// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__3UX0x","savePackageButton":"ClientWallet_savePackageButton__1Ub7I"};